import React, { useState } from 'react';
import { MainActionButton } from 'components/common/general/CollectionManagementPanel/MainActionButton';
import { Button, Tooltip } from '@insurancemenu/imenu-components-lib';
import { AlignmentTypes } from '@insurancemenu/imenu-components-lib/dist/types/Tooltip';
import {
  ActionButtonStyled,
  DropdownContentStyled,
  DropdownFooterStyled,
  DropdownHeaderStyled,
  DropdownSubtitleStyled,
  DropdownTitleStyled,
  DropdownWrapperStyled,
  ListItemHeaderSectionStyled,
  ListItemStyled,
  ListItemTextStyled,
  ListItemTitleStyled,
  ListWrapperStyled,
} from './styles';
import { PRIMARY_ACTION_DROPDOWN_TEST_IDS } from '../constants';

export interface ListItem {
  title: string;
  text: string;
  isAvailable: boolean;
  buttonLabel: string;
  buttonColor: string;
  onClick: () => void;
  dataTestId?: string;
}

interface Props {
  buttonTitle: string;
  buttonWidth?: string;
  dropdownTitle: string;
  dropdownSubtitle: string;
  listItems: ListItem[];
  cancelButtonLabel?: string;
  cancelButtonOnClick?: () => void;
  disabled?: boolean;
}

export const PrimaryActionDropdown: React.FC<Props> = ({
  buttonTitle,
  buttonWidth = '26rem',
  dropdownTitle,
  dropdownSubtitle,
  listItems,
  cancelButtonLabel = 'Cancel',
  cancelButtonOnClick,
  disabled = false,
}) => {
  const [isOpened, setIsOpened] = useState(false);

  const handleCancel = (): void => {
    setIsOpened(false);
    if (cancelButtonOnClick) {
      cancelButtonOnClick();
    }
  };

  return (
    <DropdownWrapperStyled>
      <MainActionButton
        title={buttonTitle}
        width={buttonWidth}
        opened={isOpened}
        disabled={disabled}
        onClick={() => {
          setIsOpened((prevVal) => !prevVal);
        }}
        data-test-id={PRIMARY_ACTION_DROPDOWN_TEST_IDS.MAIN_BUTTON}
      />
      {isOpened && (
        <DropdownContentStyled>
          <DropdownHeaderStyled>
            <DropdownTitleStyled>{dropdownTitle}</DropdownTitleStyled>
            <DropdownSubtitleStyled>{dropdownSubtitle}</DropdownSubtitleStyled>
          </DropdownHeaderStyled>
          <ListWrapperStyled>
            {listItems.map((item, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <ListItemStyled key={index}>
                <ListItemHeaderSectionStyled>
                  <ListItemTitleStyled>{item.title}</ListItemTitleStyled>
                  {item.isAvailable ? (
                    <ActionButtonStyled
                      type="contained"
                      color="custom"
                      customColor={item.buttonColor}
                      size="small"
                      onClick={item.onClick}
                      data-test-id={item.dataTestId}
                    >
                      {item.buttonLabel}
                    </ActionButtonStyled>
                  ) : (
                    <Tooltip label="Not available for the current configuration" alignment={AlignmentTypes.BOTTOM_END}>
                      <ActionButtonStyled type="contained" size="small" disabled data-test-id={item.dataTestId}>
                        {item.buttonLabel}
                      </ActionButtonStyled>
                    </Tooltip>
                  )}
                </ListItemHeaderSectionStyled>
                <ListItemTextStyled>{item.text}</ListItemTextStyled>
              </ListItemStyled>
            ))}
          </ListWrapperStyled>
          <DropdownFooterStyled>
            <Button
              type="outlined"
              color="primary"
              width="18rem"
              onClick={handleCancel}
              data-test-id={PRIMARY_ACTION_DROPDOWN_TEST_IDS.CANCEL_BUTTON}
            >
              {cancelButtonLabel}
            </Button>
          </DropdownFooterStyled>
        </DropdownContentStyled>
      )}
    </DropdownWrapperStyled>
  );
};
